export * from "./buildN8nRefLetterPayload";
export * from "./generateAiRefLetterForApplication";
export * from "./parseRefereeContactDetails";
export * from "./saveAiRefLetterFromWebhook";

import { ApplicantReferee, Prisma } from "@prisma/client";

import { prisma } from "@/lib/prisma";
import { calculateScore } from "@/lib/referees/utils";

/** All referees for the application (used by GTV and shared APIs). */
export async function getRefereeByApplicationId(applicationId: string) {
  return await prisma.applicantReferee.findMany({
    where: {
      applicant: {
        Application: {
          every: {
            id: applicationId,
          },
        },
      },
    },
    orderBy: { sortOrder: Prisma.SortOrder.asc },
    include: {
      relationshipTag: true,
      signatureLikelihoodTag: true,
      features: true,
    },
  });
}

/** O1 only: all referees linked to this application (broader filter so "worked with" and "didn't work with" are all included). */
export async function getRefereeByApplicationIdForO1(applicationId: string) {
  return await prisma.applicantReferee.findMany({
    where: {
      applicant: {
        Application: {
          some: {
            id: applicationId,
          },
        },
      },
    },
    orderBy: { sortOrder: Prisma.SortOrder.asc },
    include: {
      relationshipTag: true,
      signatureLikelihoodTag: true,
      features: true,
    },
  });
}

export async function getRefereeWithScoringByApplicationId(
  applicationId: string
) {
  const applicantReferees = await prisma.applicantReferee.findMany({
    where: {
      applicant: {
        Application: {
          every: {
            id: applicationId,
          },
        },
      },
    },
    orderBy: { sortOrder: Prisma.SortOrder.asc },
    include: {
      relationshipTag: true,
      signatureLikelihoodTag: true,
      features: true,
    },
  });

  // TODO: Extract to scoring fn
  const result = applicantReferees.map((x) => {
    x.scoringResult = calculateScore(x);
    return x;
  });

  return result.sort((a: ApplicantReferee, b: ApplicantReferee) => {
    const asr =
      a.scoringResultEdited !== null ? a.scoringResultEdited : a.scoringResult;
    const bsr =
      b.scoringResultEdited !== null ? b.scoringResultEdited : b.scoringResult;

    if (asr !== null && bsr !== null) {
      return asr > bsr ? -1 : asr < bsr ? 1 : 0;
    }
    return 0;
  });
}
